export const state = {
  accessTokenForWsConnection: null,
  vehicles: [],
  initialPois: [],
  realTimeRoutes: [],
  showDriverNameOnLabels: false,
  showTooltips: false,
  zoomMap: false,
  zoomToVisible: false,
  pois: [],
  selectedPois: [],
  locations: []
}

export const mutations = {
  SET_ACCESS_TOKEN(state, access_token) {
    state.accessTokenForWsConnection = access_token
  },
  SET_VEHICLES(state, vehicles) {
    vehicles.forEach(vehicle => {
      vehicle.focused = false
      vehicle.appliedFilters = {
        status: true,
        keyword: true,
        poi: true,
        group: true
      }
      vehicle.shouldDisplay = function() {
        return (
          vehicle.appliedFilters.status &&
          vehicle.appliedFilters.keyword &&
          vehicle.appliedFilters.poi &&
          vehicle.appliedFilters.group
        )
      }

      vehicle.shouldDisplayOnMap = function() {
        return (
          vehicle.appliedFilters.status &&
          vehicle.appliedFilters.keyword &&
          vehicle.appliedFilters.poi &&
          vehicle.appliedFilters.group &&
          (vehicle.focused || !vehicles.some(x => x.focused))
        )
      }

      vehicle.openInfoWindow = false

      if (vehicle.color == 3) {
        vehicle.stopped = true
      } else {
        vehicle.stopped = false
      }

      if (vehicle.poi) {
        state.initialPois.push({
          name: vehicle.poi.name,
          id: vehicle.poi.id
        })
      }

      if (!vehicle.driverName) {
        vehicle.driverName = '/'
      }
    })

    state.vehicles = vehicles
  },
  UPDATE_VEHICLE(state, vehicle) {
    let index = null

    state.vehicles.forEach((v, i) => {
      if (v.imei == vehicle.imei) {
        index = i
        return true
      }
    })

    if (index != null) {
      state.vehicles[index].angle = vehicle.angle
      state.vehicles[index].can = vehicle.can
      state.vehicles[index].color = vehicle.color
      state.vehicles[index].driver = vehicle.driver
      state.vehicles[index].driverName = vehicle.driverName
        ? vehicle.driverName
        : '/'
      state.vehicles[index].icon = vehicle.icon
      state.vehicles[index].imei = vehicle.imei
      state.vehicles[index].latitude = vehicle.latitude
      state.vehicles[index].longitude = vehicle.longitude
      state.vehicles[index].manufacturer = vehicle.manufacturer
      state.vehicles[index].packetTimestamp = vehicle.packetTimestamp
      state.vehicles[index].poi = vehicle.poi
      state.vehicles[index].poiEnteredAt = vehicle.poiEnteredAt
      state.vehicles[index].speed = vehicle.speed
      state.vehicles[index].todayKillometers = vehicle.todayKillometers
      state.vehicles[index].totalMileage = vehicle.totalMileage
      state.vehicles[index].vehicleGroupIds = vehicle.vehicleGroupIds
      state.vehicles[index].vehicleId = vehicle.vehicleId
      state.vehicles[index].vehicleLabel = vehicle.vehicleLabel
      state.vehicles[index].vehicleType = vehicle.vehicleType
      state.vehicles[index].label = vehicle.label
      state.vehicles[index].movedAt = vehicle.movedAt
      state.vehicles[index].stoppedAt = vehicle.stoppedAt
      state.vehicles[index].ioProperties = vehicle.ioProperties
      state.vehicles[index].engineBlockageButtonEnabled = vehicle.engineBlockageButtonEnabled
      state.vehicles[index].engineBlockageState = vehicle.engineBlockageState
      state.vehicles[index].tenantName = vehicle.tenantName
      state.vehicles[index].totalWorkingHours = vehicle.totalWorkingHours
      state.vehicles[index].todayWorkingHours = vehicle.todayWorkingHours
    } else {
      vehicle.focused = false
      vehicle.appliedFilters = {
        status: true,
        keyword: true,
        poi: true,
        group: true
      }
      vehicle.shouldDisplay = function() {
        return (
          vehicle.appliedFilters.status &&
          vehicle.appliedFilters.keyword &&
          vehicle.appliedFilters.poi &&
          vehicle.appliedFilters.group
        )
      }

      vehicle.shouldDisplayOnMap = function() {
        return (
          vehicle.appliedFilters.status &&
          vehicle.appliedFilters.keyword &&
          vehicle.appliedFilters.poi &&
          vehicle.appliedFilters.group &&
          (vehicle.focused || !state.vehicles.some(x => x.focused))
        )
      }

      vehicle.openInfoWindow = false

      if (vehicle.color == 3) {
        vehicle.stopped = true
      } else {
        vehicle.stopped = false
      }

      if (vehicle.poi) {
        state.initialPois.push({
          name: vehicle.poi.name,
          id: vehicle.poi.id
        })
      }

      state.vehicles.push(vehicle)
      state.zoomToVisible = true
    }
  },
  ADD_REAL_TIME_VEHICLE_ROUTE(state, route) {
    let foundRoute = state.realTimeRoutes.find(r => r.id == route.imei)

    if (foundRoute) {
      if (foundRoute.coordinates.length == 30) {
        foundRoute.coordinates.splice(0, 1)
        foundRoute.coordinatesGoogle.splice(0, 1)
      }

      foundRoute.coordinates.push([route.latitude, route.longitude])
      foundRoute.coordinatesGoogle.push({
        lat: route.latitude,
        lng: route.longitude
      })
    } else {
      state.realTimeRoutes.push({
        coordinates: [[route.latitude, route.longitude]],
        coordinatesGoogle: [{ lat: route.latitude, lng: route.longitude }],
        id: route.imei,
        color: 'green',
        visible: true
      })
    }
  },
  CHANGE_LABELS_VALUE(state, value) {
    state.showDriverNameOnLabels = value
  },
  CHANGE_TOOLTIPS_VISIBILITY(state, value) {
    state.showTooltips = value
  },
  ZOOM_MAP(state) {
    state.zoomMap = !state.zoomMap
  },
  ADD_POI(state, poi) {
    state.pois.push(poi)
  },
  ADD_SINGLE_POI(state, poi) {
    state.pois = [poi]
  },
  CLEAR_POI_DATA() {
    state.pois = []
  },
  CLEAR_ONE_POI(state, poi) {
    let pois = state.pois
    state.pois = []
    pois.forEach(x => {
      if (x.id != poi.id) {
        state.pois.push(x)
      }
    })
  },
  ZOOM_TO_ALL_VISIBLE_VEHICLES(state) {
    state.zoomToVisible = !state.zoomToVisible
  },
  SET_SELECTED_POIS(state, selectedPois) {
    state.selectedPois = selectedPois
  },
  CLEAR_VEHICLE_DATA() {
    state.vehicles = []
    state.realTimeRoutes = []
  },
  ADD_LOCATION(state, location) {
    state.locations.push(location)
  },
  REMOVE_LOCATION(state, location) {
    let locations = state.locations.filter(x => x.id != location.id)
    state.locations = locations
  }
}

export const actions = {
  getAccessToken({ commit, dispatch }, access_token) {
    if (access_token) {
      commit('SET_ACCESS_TOKEN', JSON.parse(access_token).accessToken)
    } else {
      const notification = {
        type: 'error',
        message: 'Unexpected error. Could not establish connection with server.'
      }

      dispatch('notification/add', notification, { root: true })
    }
  },
  saveVehicles({ commit, dispatch }, vehicles) {
    commit('SET_VEHICLES', vehicles)
    vehicles.forEach(vehicle => {
      dispatch('addRealTimeVehicleRoute', vehicle)
    })
  },
  updateVehicle({ commit, dispatch }, vehicle) {
    commit('UPDATE_VEHICLE', vehicle)
    dispatch('addRealTimeVehicleRoute', vehicle)
  },
  addRealTimeVehicleRoute({ commit }, route) {
    commit('ADD_REAL_TIME_VEHICLE_ROUTE', route)
  },
  changeLabelsValue({ commit }, labelsValue) {
    commit('CHANGE_LABELS_VALUE', labelsValue)
  },
  changeTooltipsVisibility({ commit }, tooltipsValue) {
    commit('CHANGE_TOOLTIPS_VISIBILITY', tooltipsValue)
  },
  zoomMap({ commit }) {
    commit('ZOOM_MAP')
  },
  addPoi({ commit }, poi) {
    commit('ADD_POI', poi)
  },
  clearPois({ commit }) {
    commit('CLEAR_POI_DATA')
  },
  showSinglePoi({ commit }, poi) {
    commit('ADD_SINGLE_POI', poi)
  },
  zoomToAllVisibleVehicles({ commit }) {
    commit('ZOOM_TO_ALL_VISIBLE_VEHICLES')
  },
  setSelectedPois({ commit }, selectedPois) {
    commit('SET_SELECTED_POIS', selectedPois)
  },
  clearVehicleData({ commit }) {
    commit('CLEAR_VEHICLE_DATA')
  },
  addLocation({ commit }, location) {
    commit('ADD_LOCATION', location)
  },
  removeLocation({ commit }, location) {
    commit('REMOVE_LOCATION', location)
  },
  clearOnePoi({ commit }, poi) {
    commit('CLEAR_ONE_POI', poi)
  }
}

export const getters = {
  accessToken: state => {
    return state.accessTokenForWsConnection
  },
  getVehicles: state => {
    return state.vehicles
  },
  getRealTimeRoutes: state => {
    return state.realTimeRoutes
  }
}

export const namespaced = true
